export const EXIT_INTENT_EXPERIMENT_NAME = 'card_6394_cardfinder_real_exit_intent';
